module.exports = "<gw-qnb-pa-mobile-summary ng-if=\"$ctrl.lobCode() === 'personalAuto'\"\r\n                          offering=\"$ctrl.offering\"\r\n                          branch-code=\"$ctrl.branchCode\">\r\n</gw-qnb-pa-mobile-summary>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/integration/quoteandbind/directives/LobOfferingSelection/mobileQuoteView/mobileLobSummary/mobileLobSummary.html
// module id = 1099
// module chunks = 0